<template>
  <div class="appointment-membership" id="internal">
    <div class="container-mobile" v-if="isMobile">
      <img :src="moduleData.img_url" class="content-img" />
      <div class="container-box">
        <div class="form-list">
          <input
            type="text"
            v-model="formData.name"
            placeholder="请输入您的姓名"
            @blur="verifyName"
          />
        </div>
        <div class="form-list">
          <input
            type="text"
            v-model="formData.identityCard"
            placeholder="请输入身份证号"
            maxlength="18"
            @blur="verifyIdentityCard"
          />
        </div>
        <div class="form-list">
          <input
            type="text"
            v-model="formData.identityValidity"
            placeholder="请选择您的身份证有效期"
            readonly
            @focus="focusValidity"
          />
        </div>
        <div class="form-list">
          <input
            type="tel"
            v-model="formData.mobilePhone"
            placeholder="请输入您的手机号码"
            maxlength="11"
            @blur="verifyPhone"
          />
        </div>
        <div class="form-list">
          <input
            type="tel"
            v-model="formData.phoneCode"
            placeholder="请输入验证码"
            maxlength="6"
            @blur="verifyPhoneCode"
          />
          <span @click="getPhoneCode">{{ getPh.text }}</span>
        </div>
        <div class="protocol">
          <input
            type="checkbox"
            checked
            class="register-checkbox"
            v-model="formData.promise"
          />
          <p>
            我已阅读并同意<a href="/protocol/index" target="_blank"
          >《诺亚网络服务使用协议》</a
          >和<a href="/person/index" target="_blank">《个人信息保护协议》</a>
          </p>
        </div>
        <div class="submit-btn" @click="submit"></div>
        <van-popup v-model="showDatePopup" position="bottom">
          <van-datetime-picker
            v-model="identityValidity"
            type="date"
            title="选择身份证有效期"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="confirmDate"
            @cancel="showDatePopup = false"
          >
            <div slot="columns-bottom" class="datetime-footer" @click="longTerm('mobile')">长期有效</div>
          </van-datetime-picker>
        </van-popup>
      </div>
    </div>
    <div class="container-pc" v-else>
      <img :src="moduleData.img_url" class="content-img" />
      <div class="container-box">
        <div class="form-list">
          <div class="form-logo">
            <img src="../../assets/images/user.png" alt="">
          </div>
          <input
            type="text"
            v-model="formData.name"
            placeholder="请输入您的姓名"
            @blur="verifyName"
          />
          <p class="notice">{{ errorMessage.name }}</p>
        </div>
        <div class="form-list">
          <div class="form-logo">
            <img src="../../assets/images/card-id.png" alt="" style="height: 0.24rem">
          </div>
          <input
            type="text"
            v-model="formData.identityCard"
            placeholder="请输入身份证号"
            maxlength="18"
            @blur="verifyIdentityCard"
          />
          <p class="notice">{{ errorMessage.identityCard }}</p>
        </div>
        <div class="form-list">
          <div class="form-logo">
            <img src="../../assets/images/time.png" alt="">
          </div>
          <a-date-picker
            v-model="identityValidity"
            placeholder="请选择您的身份证有效期"
            :showToday="false"
            :open="pickerOpen"
            valueFormat="YYYY-MM-DD"
            @openChange="openPicker"
            @change="changePicker">
            <input type="text" v-model="formData.identityValidity" placeholder="请选择您的身份证有效期">
            <div class="calender-footer-box" slot="renderExtraFooter">
              <a class="ant-calendar-today-btn" @click="longTerm('pc')">长期有效</a>
            </div>
          </a-date-picker>
          <p class="notice">{{ errorMessage.identityValidity }}</p>
        </div>
        <div class="form-list">
          <div class="form-logo">
            <img src="../../assets/images/mobile.png" alt="">
          </div>
          <input
            type="tel"
            v-model="formData.mobilePhone"
            placeholder="请输入您的手机号码"
            maxlength="11"
            @blur="verifyPhone"
          />
          <p class="notice">{{ errorMessage.mobilePhone }}</p>
        </div>
        <div class="form-list">
          <div class="form-logo">
            <img src="../../assets/images/suo.png" alt="">
          </div>
          <input
            type="tel"
            v-model="formData.phoneCode"
            placeholder="请输入验证码"
            maxlength="6"
            @blur="verifyPhoneCode"
          />
          <span @click="getPhoneCode" class="phone-code">{{ getPh.text }}</span>
          <p class="notice">{{ errorMessage.phoneCode }}</p>
        </div>
        <div class="protocol">
          <input
            type="checkbox"
            checked
            class="register-checkbox"
            v-model="formData.promise"
          />
          <p>
            我已阅读并同意<a href="/protocol/index" target="_blank"
          >《诺亚网络服务使用协议》</a
          >和<a href="/person/index" target="_blank">《个人信息保护协议》</a>
          </p>
        </div>
        <div class="submit-btn" @click="submit"></div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="step == 3 && showModal">
      <smile-success v-if="moduleData.result_modal == 1" @close-modal="closeModal" />
      <mobile-success v-else-if="isMobile" @close-modal="closeModal" />
      <pc-success v-else @close-modal="closeModal" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import util from '../../assets/js/util'
import encrypt, { Decrypt } from '../../api/encrypt'
import { getAccountInfo, traceLog } from '../../api/api'
import SmileSuccess from '../resultModal/smile-success'
import MobileSuccess from '../resultModal/mobile-success'
import PcSuccess from '../resultModal/pc-success'
import { DatePicker } from 'ant-design-vue'
import { Popup } from 'vant'
import { DatetimePicker } from 'vant'
import moment from 'moment'
import 'vant/lib/index.css'
import {getSearchString, saveExternalUser} from '../index'
Vue.use(DatePicker)
Vue.use(Popup)
Vue.use(DatetimePicker)
function getQueryStringAll(params) {
  const str = location.search.substring(1).split("&")
  for (let i = 0; i < str.length; i++) {
    const val = str[i].split('=')
    if (!val[0]) break
    params.note[val[0]] = val[1]
  }
  params.note = JSON.stringify(params.note)
  return params
}
// 时间戳转化成时间
export function timetrans(time){
  const date = new Date(time)
  const Y = date.getFullYear() + '-';
  const M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  const D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  return Y+M+D
}
const regName = /^[\u4e00-\u9fa5]{2,5}$/;
const regPhone = /^1[3456789]\d{9}$/;
const regPhoneCode = /[\d]{6}/;
const regIdentityCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
const regIdentityValidity = /^(\d{4})(-)(\d{2})(-)(\d{2})|长期有效$/
const basicData = {
  name: '',
  mobilePhone: '',
  phoneCode: '',
  identityCard: '',
  identityValidity: '',
  promise: false
}
export default {
  name: 'AppointmentMembership',
  components: {
    SmileSuccess,
    MobileSuccess,
    PcSuccess
  },
  props: {
    step: {
      type: Number,
    },
    partyId: {
      type: String,
    },
    pageType: {
      type: Number,
    },
    pageName: {
      type: String,
    },
    showModal: {
      type: Boolean,
    },
    moduleData: {
      type: Object,
    },
    hasFa: {
      type: Boolean,
    },
    pageInfo: {
      type: Object,
    },
    needKYC: {
      type: Boolean,
    }
  },
  data () {
    return {
      isMobile: util.device.isMobile,
      formData: { ...basicData },
      errorMessage: { ...basicData },
      hasGroupNo: false,
      groupNo: '',
      type: '209',
      getPh: {
        text: '获取验证码',
        boolean: false,
      },
      pickerOpen: false,
      showDatePopup: false,
      minDate: new Date(),
      maxDate: new Date('2099-12-31'),
      identityValidity: '',
      submitLoading: false
    }
  },
  methods: {
    moment,
    getPhoneCode() {
      if (this.getPh.boolean) return
      if (this.verifyValidate('mobilePhone', regPhone, { emptyError: '请输入您的手机号', failError: '请输入11位手机号' })) {
        util
          .ajax({
            reqData: [
              {
                method: 'common.send_phone_code',
                params: {
                  phone: this.formData.mobilePhone,
                  method: '1',
                  type: this.type
                }
              }
            ]
          })
          .then((err, resArr) => {
            let second = 59
            let inter = undefined
            this.getPh.text = second + '秒后重发'
            this.getPh.boolean = true
            inter = setInterval(() => {
              if (second == 0) {
                this.getPh.text = '重新发送'
                this.formData.mobilePhone = ''
                clearInterval(inter)
                this.getPh.boolean = false
              } else {
                second = second - 1
                this.$set(this.getPh, 'text', second + '秒后重发')
              }
            }, 1000)
          })
      }
    },
    verifyValidate (key, reg, message) {
      if (this.formData[key] == '') {
        this.errorMessage[key] = message.emptyError
        if (this.isMobile) this.$toast.show(this.errorMessage[key], 2)
        return false
      } else if (!reg.test(this.formData[key])) {
        this.errorMessage[key] = message.failError
        if (this.isMobile) this.$toast.show(this.errorMessage[key], 2)
        return false
      } else {
        this.errorMessage[key] = ''
        return true
      }
    },
    verifyName() {
      return this.verifyValidate('name', regName, { emptyError: '请输入您的姓名', failError: '仅可输入2~5位中文姓名' })
    },
    verifyPhone() {
      return this.verifyValidate('mobilePhone', regPhone, { emptyError: '请输入您的手机号码', failError: '请输入正确的大陆手机号码' })
    },
    verifyPhoneCode() {
      return this.verifyValidate('phoneCode', regPhoneCode, { emptyError: '请输入验证码', failError: '请输入正确验证码' })
    },
    verifyIdentityCard() {
      return this.verifyValidate('identityCard', regIdentityCard, { emptyError: '请输入身份证号', failError: '请输入正确的身份证号' })
    },
    verifyIdentityValidity() {
      return this.verifyValidate('identityValidity', regIdentityValidity, { emptyError: '请选择您的身份证有效期', failError: '请选择您的身份证有效期' })
    },
    longTerm(type) {
      this.formData.identityValidity = '长期有效'
      if (type === 'pc') {
        this.pickerOpen = false
        this.identityValidity = ''
      } else {
        this.showDatePopup = false
      }
    },
    openPicker (status) {
      this.pickerOpen = status
    },
    changePicker (date) {
      this.formData.identityValidity = date
      this.verifyIdentityValidity()
    },
    focusValidity () {
      this.showDatePopup = true
    },
    confirmDate (value) {
      this.formData.identityValidity = timetrans(value)
      this.showDatePopup = false
    },
    checkValidate () {
      this.errorMessage = { ...basicData }
      if (!this.verifyName()
        || !this.verifyIdentityCard()
        || !this.verifyIdentityValidity()
        || !this.verifyPhone()
        || !this.verifyPhoneCode()) {
        return false
      }
      if (!this.formData.promise) {
        this.$toast.show("请您阅读并同意相关协议", 2)
        return false
      }
      return true
    },
    // 检查是否有绑定理财师
    checkBindFa (sid) {
      const bindParams = {
        mobilePhone: this.formData.mobilePhone
      }
      util.ajax({
        header: { 'X-KGW-SID': sid },
        reqData: [
          {
            method: 'active.customer_is_bind_fa',
            params: bindParams
          }
        ]
      }).then((err, resArr) => {
        // isBindFa 1 有绑定的理财师
        this.submitLoading = false
        this.$emit('setHasFa', !!resArr[1].result && resArr[1].result.isBindFa == '1')
        this.nextStep(1)
        this.handleSave()
        /**
         * 入会成功埋点
         */
        const external_userid = getSearchString('userid') && decodeURIComponent(getSearchString('userid'))
        const follow_user_state = getSearchString('followState') && decodeURIComponent(getSearchString('followState'))
        const fa_mail = getSearchString('inviteEmail') && decodeURIComponent(getSearchString('inviteEmail'))
        const fa_id = getSearchString('inviteUserid') && decodeURIComponent(getSearchString('inviteUserid'))
        const from_corp = getSearchString('fromCorp') && decodeURIComponent(getSearchString('fromCorp'))
        const needKYC = !!resArr[1].result && resArr[1].result.isBindFa == '1' ? '否' : this.needKYC ? '是' : '否'
        this.$sensors.track('pptf_profile_success', {
          ...this.pageInfo,
          needKYC: needKYC,
          is_first_time: this.hasGroupNo ? '否' : '是',
          customer_id: this.groupNo,
          external_userid: external_userid ? Decrypt(external_userid) : '',
          follow_user_state: follow_user_state ? Decrypt(follow_user_state) : '',
          fa_mail: fa_mail ? Decrypt(fa_mail) : '',
          fa_id: fa_id ? Decrypt(fa_id) : '',
          from_corp: from_corp ? from_corp : ''
        })
      })
    },
    // 保存注册信息入库
    handleSave () {
      const pubKey =
        '-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKwXxvLaOA1f/dVRQgS76HRrgRh8N7jqYScrSciQYtNtJ5hpCHmSHdjHXe4IK9lOT5SJHhZLXg/c2tFhvicoxAsCAwEAAQ==-----END PUBLIC KEY-----'
      const phone = encrypt(pubKey, this.formData.mobilePhone)
      const cardNo = encrypt(pubKey, this.formData.identityCard)
      traceLog({
        page_name: this.pageName, // 默认 为 0
        user_name: this.formData.name || '匿名',
        phone: phone,
        card_no: cardNo,
        valid_time: this.formData.identityValidity.indexOf('长期有效') > -1 ? '9999-12-31' : this.formData.identityValidity,
        group_no: this.groupNo,
        from_url: encodeURI(location.href) // 需要url编码
      }).then((resLog) => {
        const reserveId = resLog.data.reserveId
        localStorage.setItem('reserveId', reserveId)
      })
    },
    // 注册提交
    async submit () {
      if (!this.checkValidate()) return
      if (this.submitLoading) return
      this.submitLoading = true
      const preParams = {
        ...this.formData,
        note: { partyId: this.partyId },
        partyId: this.partyId,
        city: this.$route.query.city || ''
      }
      delete preParams.identityCard
      delete preParams.identityValidity
      const params = getQueryStringAll(preParams)
      /**
       * 查询是否首次注册
       * 2021-6-1 zhl
       */
      const pubKey =
        "-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKwXxvLaOA1f/dVRQgS76HRrgRh8N7jqYScrSciQYtNtJ5hpCHmSHdjHXe4IK9lOT5SJHhZLXg/c2tFhvicoxAsCAwEAAQ==-----END PUBLIC KEY-----";
      const mobilePhone = encrypt(pubKey, this.formData.mobilePhone);
      const infoData = await getAccountInfo({ phone: mobilePhone })
      if (infoData.data && infoData.data.code === 1) {
        this.hasGroupNo = infoData.data.data.hasGroupNo
        this.$emit('setFirstTime', this.hasGroupNo)
      }
      // 注册
      util.ajax({
        reqData: [
          {
            method: 'active.baidu_potential_customer',
            params: params,
          }
        ]
      }).then((err, resArr) => {
        const sid = resArr[0].result;
        localStorage.setItem('sid', sid)
        if (resArr[1].result && resArr[1].result.code === '0') {
          /**
           * 注册成功获取集团号
           * 2021-6-1 zhl
           */
          this.groupNo = resArr[1].result['group_no']
          this.$emit('setGroupNo', this.groupNo)
          this.checkBindFa(sid)
          saveExternalUser(this.formData.mobilePhone, this.groupNo)
        } else {
          this.submitLoading = false
          this.errorMessage.phoneCode = resArr[1].error.message
          if (this.isMobile) this.$toast.show(resArr[1].error.message, 2)
          /**
           * 入会失败埋点
           */
          this.$sensors.track('pptf_profile_failed', {
            ...this.pageInfo
          })
        }
      })
    },
    nextStep(step) {
      this.$emit('setStep', step + 1)
    },
    closeModal() {
      this.formData.mobilePhone = ''
      this.$emit('setShowModal', false)
    }
  }
}
</script>

<style lang="less" scoped>
input:focus {
  outline: none;
  border: none;
}
.calender-footer-box {
  text-align: center;
}
.datetime-footer {
  text-align: center;
  line-height: 1.2rem;
  color: #576b95;
}
.container-mobile {
  position: relative;
  width: 7.5rem;
  height: 10rem;
  img {
    width: 7.5rem;
    height: 10rem;
  }
  .container-box {
    position: absolute;
    top: 0.8rem;
    left: 0;
    height: 8.4rem;
    width: 7.5rem;
    padding: 0 0.48rem;
    box-sizing: border-box;
    .form-list {
      height: 0.96rem;
      width: 6.54rem;
      margin-bottom: 0.34rem;
      position: relative;
      input {
        height: 0.96rem;
        width: 100%;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 0.096rem;
        border: 1px solid #CCCCCC;
        vertical-align: top;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        padding-left: 0.34rem;
        font-size: 0.3rem;
        outline: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
      }
      & > span {
        width: 1.96rem;
        height: 0.48rem;
        line-height: 0.48rem;
        position: absolute;
        right: 0;
        top: 0.24rem;
        color: #c49368;
        font-size: 0.3rem;
        text-align: center;
        background: transparent;
        border-left: 1px solid #dcdfe6;
      }
    }
    .protocol {
      width: 100%;
      height: 0.72rem;
      position: relative;
      color: #666666;
      p {
        position: absolute;
        top: 0;
        left: 0.36rem;
        line-height: 0.36rem;
        font-size: 0.24rem;
      }
      a {
        text-decoration: none;
        color: #cda077;
      }
      .register-checkbox {
        appearance: none;
        -webkit-appearance: none;
        vertical-align: middle;
        border-radius: 0;
        color: #f3c99c;
        line-height: 1;
        width: 0.28rem;
        height: 0.28rem;
        background: url("../../assets/images/internal_agree_no.png") center / contain
        no-repeat;
        position: absolute;
        top: 0.04rem;
        cursor: pointer;
      }
      .register-checkbox:checked::before {
        display: block;
        width: 0.28rem;
        height: 0.28rem;
        content: "";
        background: url("../../assets/images/internal_agree_yes.png") center / contain
        no-repeat;
        color: #000;
        font-size: 0.337rem;
      }
    }
    .submit-btn {
      width: 100%;
      height: 0.96rem;
      margin-top: 0.2rem;
    }
  }
}
.container-pc {
  width: 100%;
  position: relative;
  img {
    width: 100%;
  }
  .container-box {
    position: absolute;
    width: 5.17rem;
    height: 6.95rem;
    right: 1.58rem;
    top: 1.25rem;
    padding: 0.5rem 0.32rem;
    box-sizing: border-box;
    .form-list {
      height: 0.58rem;
      width: 4.53rem;
      margin-bottom: 0.34rem;
      position: relative;
      .form-logo {
        position: absolute;
        top: 0;
        left: 0;
        width: 0.58rem;
        height: 0.58rem;
        background: #BDBDBD;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        img {
          height: 0.28rem;
          width: auto;
        }
      }
      input {
        height: 0.58rem;
        width: 100%;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 0.048rem;
        border: 1px solid #CCCCCC;
        vertical-align: top;
        line-height: 0.58rem;
        padding-left: 0.78rem;
        font-size: 0.22rem;
        color: #303133;
        &:focus {
          border: 1px solid #e3bb98;
        }
        &::-webkit-input-placeholder {
          color: #CCCCCC;
        }
      }
      .ant-calendar-picker {
        width: 100%;
      }
      & > .phone-code {
        width: 1.4rem;
        height: 0.28rem;
        line-height: 0.28rem;
        position: absolute;
        right: 0;
        top: 0.15rem;
        color: #c49368;
        font-size: 0.22rem;
        text-align: center;
        background: transparent;
        border-left: 1px solid #dcdfe6;
      }
      .notice {
        position: absolute;
        top: 0.58rem;
        left: 0.13rem;
        color: red;
        font-size: 0.18rem;
        line-height: 0.24rem;
      }
    }
    .protocol {
      width: 100%;
      height: 0.54rem;
      position: relative;
      color: #ffffff;
      p {
        position: absolute;
        top: 0;
        left: 0.36rem;
        line-height: 0.27rem;
        font-size: 0.18rem;
        color: #CCCCCC;
      }
      a {
        text-decoration: none;
        color: #cda077;
      }
      .register-checkbox {
        appearance: none;
        -webkit-appearance: none;
        vertical-align: middle;
        border-radius: 0;
        color: #f3c99c;
        line-height: 1;
        width: 0.24rem;
        height: 0.24rem;
        background: url("../../assets/images/internal_agree_no.png") center / contain
        no-repeat;
        position: absolute;
        top: 0.04rem;
        cursor: pointer;
      }
      .register-checkbox:checked::before {
        display: block;
        width: 0.24rem;
        height: 0.24rem;
        content: "";
        background: url("../../assets/images/internal_agree_yes.png") center / contain
        no-repeat;
        color: #000;
        font-size: 0.337rem;
      }
    }
    .submit-btn {
      width: 100%;
      height: 0.58rem;
      margin-top: 0.24rem;
      cursor: pointer;
    }
  }
}
.modal-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/appointment-membership.vue